import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  useTheme,
  useMediaQuery,
  Avatar,
  Chip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress
} from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import {
  PieChart,
  BarChart,
  LineChart
} from '@mui/x-charts';
import {
  People as PeopleIcon,
  Business as BusinessIcon,
  TrendingUp as TrendingUpIcon,
  DateRange as DateRangeIcon,
  DocumentScanner as DocumentIcon,
  AttachMoney as PaidUserIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../utils/loader';
import AdminServices from '../services/adminServices';
import {
  getOrgUserPlanBreakdown,
  getOrgUsersForBarChart,
  getOrganisationData,
  getSuperAdminDashCards,
  getUserCountryCodeBreakdown,
  getUserPlanBreakdown,
  getYearList
} from '../services/dashboardServices';

// Modern gradient colors
const COLORS = ['#667eea', '#764ba2', '#f093fb', '#4facfe'];

const ModernAdminDashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // State from old functionality
  const [dashboardData, setDashboardData] = useState({
    totalFreeUser: 0,
    totalPaidUser: 0,
    totalDocuments: 0,
    monthWiseDocuments: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    monthWiseUser: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    monthwisePaidusers: [],
    monthwiseFreeusers: [],
    admindashdetail: [],
    selectYear: new Date().getFullYear(),
    years: [...Array(Number(new Date().getFullYear()) - 2018)].map((year, i) => 2019 + i),
    monthList: ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"]
  });

  const [imageCardData, setImageCardData] = useState({
    individualUsers: "0",
    registeredOrganization: "0",
    totalOrgUsers: "0"
  });

  const [yearList, setYearList] = useState([]);
  const [barChartYear, setBarChartYear] = useState(new Date().getFullYear());
  const [pieChartOrg, setPieChartOrg] = useState('');
  const [organizationList, setOrganizationList] = useState([]);
  
  const [countryCodePieChart, setCountryCodePieChart] = useState([]);
  const [userPlanBreakdownPieChart, setUserPlanBreakdownPieChart] = useState([]);
  const [orgUsersPlanBreakdown, setOrgUsersPlanBreakdown] = useState([]);
  
  const [orgUserBarChart, setOrgUserBarChart] = useState({
    xAxisBar: "",
    xAxisList: [],
    lineData: [],
    bar: [],
  });

  // Initialize theme and window width
  useEffect(() => {
    const updateTheme = () => {
      const themeValue = localStorage.getItem('ThemeSwitch');
      setIsDarkMode(themeValue === 'true');
    };
    
    updateTheme();
    window.addEventListener('storage', updateTheme);
    
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === 'ThemeSwitch') {
        updateTheme();
      }
    };

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('storage', updateTheme);
      localStorage.setItem = originalSetItem;
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Fetch all initial data
  useEffect(() => {
    const year = new Date().getFullYear();
    fetchYearList();
    fetchOrganizationList();
    getImageCardDetails();
    getUserPlanPieChart();
    getUserCountryBreakdown();
    getDetailsAdminDash(year);
    getmonthwisePaidusers(year);
    getmonthwiseFreeusers(year);
    getOrgUserBarChartData(year);
  }, []);

  // Helper functions
  const convertForPieChart = (arr) => {
    let finalArr = []
    arr.forEach((obj) => {
      if (obj.value > 0) {
        finalArr.push({
          id: finalArr.length,
          value: Number(obj.value),
          label: obj.title,
          color: obj.color || COLORS[finalArr.length % COLORS.length]
        })
      }
    })
    return finalArr
  }

  const fetchYearList = async () => {
    setLoading(true);
    try {
      let response = await getYearList();
      if (response.status === 200) {
        let finalArr = response.yearList.map((obj) => ({ name: obj, value: obj }));
        setYearList(finalArr);
      }
    } catch (error) {
      console.error("Error fetching year list:", error);
      toast.error("Failed to load year list");
    }
    setLoading(false);
  };

  const fetchOrganizationList = async () => {
    setLoading(true);
    try {
      // Get user ID from your state management or context
      // const userID = "your-user-id"; // Replace with actual user ID
      // let response = await getOrganisationData(userID);
      // if (response.status === 200) {
      //   let finalArr = response.orgDetails.map((obj) => ({ name: obj.orgName, value: obj.orgId }));
      //   setOrganizationList(finalArr);
      // }
      
      // Mock data for now
      setOrganizationList([
        { name: "Org 1", value: "org1" },
        { name: "Org 2", value: "org2" },
        { name: "Org 3", value: "org3" }
      ]);
    } catch (error) {
      console.error("Error fetching organization list:", error);
      toast.error("Failed to load organizations");
    }
    setLoading(false);
  };

  const getImageCardDetails = async () => {
    try {
      // const userID = "your-user-id"; // Replace with actual user ID
      // let response = await getSuperAdminDashCards(userID);
      // let { individualUsers, registeredOrg, orgnizationUsers } = response;
      // setImageCardData({
      //   individualUsers: individualUsers.toString(),
      //   registeredOrganization: registeredOrg.toString(),
      //   totalOrgUsers: orgnizationUsers.toString()
      // });
      
      // Mock data
      setImageCardData({
        individualUsers: "2,847",
        registeredOrganization: "124",
        totalOrgUsers: "1,523"
      });
    } catch (e) {
      console.error("Error fetching image card details:", e);
      toast.error("Failed to load dashboard cards");
    }
  };

  const getUserPlanPieChart = async () => {
    try {
      // const userID = "your-user-id"; // Replace with actual user ID
      // let response = await getUserPlanBreakdown(userID);
      // let finalData = convertForPieChart(response.data);
      // setUserPlanBreakdownPieChart(finalData);
      // setOrgUsersPlanBreakdown(finalData);
      
      // Mock data
      const mockData = [
        { title: "Free Plan", value: 45, color: "#667eea" },
        { title: "Basic Plan", value: 30, color: "#764ba2" },
        { title: "Pro Plan", value: 25, color: "#f093fb" }
      ];
      const finalData = convertForPieChart(mockData);
      setUserPlanBreakdownPieChart(finalData);
      setOrgUsersPlanBreakdown(finalData);
    } catch (e) {
      console.error("Error fetching user plan breakdown:", e);
      toast.error("Failed to load user plan data");
    }
  };

  const getUserCountryBreakdown = async () => {
    try {
      // const userID = "your-user-id"; // Replace with actual user ID
      // let response = await getUserCountryCodeBreakdown(userID);
      // let finalData = convertForPieChart(response.data);
      // setCountryCodePieChart(finalData);
      
      // Mock data
      const mockData = [
        { title: "USA", value: 35, color: "#667eea" },
        { title: "India", value: 25, color: "#764ba2" },
        { title: "UK", value: 20, color: "#f093fb" },
        { title: "Others", value: 20, color: "#4facfe" }
      ];
      const finalData = convertForPieChart(mockData);
      setCountryCodePieChart(finalData);
    } catch (e) {
      console.error("Error fetching country breakdown:", e);
      toast.error("Failed to load country data");
    }
  };

  const getOrgUserBarChartData = async (year) => {
    setLoading(true);
    try {
      // const userID = "your-user-id"; // Replace with actual user ID
      // let response = await getOrgUsersForBarChart(userID, year);
      // let finalData = response.data;
      // let { xAxisBar, xAxisList, bar } = finalData;
      // setOrgUserBarChart({
      //   ...orgUserBarChart,
      //   xAxisBar: xAxisBar,
      //   xAxisList: xAxisList,
      //   bar: bar
      // });
      
      // Mock data
      const xAxisList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
      const barData = xAxisList.map(() => Math.floor(Math.random() * 100) + 20);
      
      setOrgUserBarChart({
        xAxisBar: "Organization Users",
        xAxisList: xAxisList,
        bar: barData
      });
    } catch (e) {
      console.error("Error fetching bar chart data:", e);
      toast.error("Failed to load organization user data");
      setOrgUserBarChart({
        xAxisBar: "",
        xAxisList: [],
        bar: []
      });
    }
    setLoading(false);
  };

  const getOrgUserPlanPieChartData = async (orgID) => {
    setLoading(true);
    try {
      // const userID = "your-user-id"; // Replace with actual user ID
      // let response = await getOrgUserPlanBreakdown(userID, orgID);
      // let finalData = convertForPieChart(response.data);
      // if (finalData.length > 0) {
      //   setOrgUsersPlanBreakdown(finalData);
      // } else {
      //   toast.warn("No data available for selected organization");
      // }
      
      // Mock data based on organization
      const mockData = [
        { title: "Free Plan", value: Math.floor(Math.random() * 50) + 20, color: "#667eea" },
        { title: "Basic Plan", value: Math.floor(Math.random() * 40) + 10, color: "#764ba2" },
        { title: "Pro Plan", value: Math.floor(Math.random() * 30) + 5, color: "#f093fb" }
      ];
      const finalData = convertForPieChart(mockData);
      setOrgUsersPlanBreakdown(finalData);
    } catch (e) {
      console.error("Error fetching organization plan data:", e);
      toast.error("Failed to load organization plan data");
    }
    setLoading(false);
  };

  const getDetailsAdminDash = async (year) => {
    setLoading(true);
    try {
      const {
        totalDocuments,
        totalFreeuser,
        totalPaidUser,
        monthWiseDocuments,
        monthWiseUser
      } = await AdminServices.getDetailsAdminDash(year);

      setDashboardData(prev => ({
        ...prev,
        totalFreeUser: totalFreeuser,
        totalPaidUser: totalPaidUser,
        totalDocuments: totalDocuments,
        monthWiseDocuments: monthWiseDocuments,
        monthWiseUser: monthWiseUser,
        selectYear: year
      }));

      await getmonthwisePaidusers(year);
      await getmonthwiseFreeusers(year);
    } catch (error) {
      console.error("Error fetching admin dashboard data:", error);
      toast.error("Failed to load dashboard statistics");
    }
    setLoading(false);
  };

  const getmonthwisePaidusers = async (year) => {
    try {
      const admindata = await AdminServices.getPaidUserDetails(year);
      setDashboardData(prev => ({ ...prev, monthwisePaidusers: admindata.monthWisePaidUser }));
    } catch (error) {
      console.error("Error fetching paid user data:", error);
    }
  };

  const getmonthwiseFreeusers = async (year) => {
    try {
      const admindata = await AdminServices.getFreeUserDetails(year);
      setDashboardData(prev => ({ ...prev, monthwiseFreeusers: admindata.monthWiseFreeUser }));
    } catch (error) {
      console.error("Error fetching free user data:", error);
    }
  };

  const handleBarChartYearChange = (year) => {
    const currentYear = new Date().getFullYear();
    if (year > currentYear) {
      toast.warn("Please enter current or past year");
      return;
    }
    setBarChartYear(year);
    getOrgUserBarChartData(year);
  };

  const handlePieChartOrgChange = (orgID) => {
    setPieChartOrg(orgID);
    getOrgUserPlanPieChartData(orgID);
  };

  const handleYearChange = (year) => {
    getDetailsAdminDash(year);
    setDashboardData(prev => ({ ...prev, selectYear: year }));
  };

  // Prepare series data for MUI X Charts
  const orgUsersSeries = [
    {
      data: orgUserBarChart.bar.length > 0 ? orgUserBarChart.bar : [65, 78, 90, 81, 95, 110],
      label: orgUserBarChart.xAxisBar || 'Organization Users',
      color: '#667eea'
    }
  ];

  const monthlyActiveSeries = [
    {
      data: dashboardData.monthwisePaidusers.length > 0 
        ? dashboardData.monthwisePaidusers 
        : [65, 78, 90, 81, 95, 110],
      label: 'Monthly Active Users',
      color: '#764ba2'
    }
  ];

  const xAxisData = orgUserBarChart.xAxisList.length > 0 
    ? orgUserBarChart.xAxisList 
    : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];

  // Components
  const StatCard = ({ title, value, icon: Icon, color, subtitle, linkTo }) => {
    const cardContent = (
      <Card
        elevation={0}
        sx={{
          height: '100%',
          background: isDarkMode 
            ? 'linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%)'
            : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
          borderRadius: 3,
          border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: isDarkMode 
              ? '0 12px 24px rgba(0,0,0,0.4)'
              : '0 12px 24px rgba(0,0,0,0.1)'
          },
          cursor: linkTo ? 'pointer' : 'default'
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Avatar
              sx={{
                bgcolor: `${color}20`,
                width: 56,
                height: 56
              }}
            >
              <Icon sx={{ color, fontSize: 28 }} />
            </Avatar>
            <Chip
              label="+12%"
              size="small"
              sx={{
                bgcolor: '#4caf5020',
                color: '#4caf50',
                fontWeight: 600
              }}
            />
          </Box>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: isDarkMode ? '#fff' : '#1a1a1a',
              mb: 0.5
            }}
          >
            {value}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: isDarkMode ? '#b0b0b0' : '#666',
              fontWeight: 500,
              mb: subtitle ? 1 : 0
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="caption"
              sx={{
                color: isDarkMode ? '#808080' : '#999',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5
              }}
            >
              {subtitle}
            </Typography>
          )}
        </CardContent>
      </Card>
    );

    if (linkTo) {
      return (
        <Link to={linkTo} style={{ textDecoration: 'none' }}>
          {cardContent}
        </Link>
      );
    }

    return cardContent;
  };

  const ChartCard = ({ 
    title, 
    children, 
    action, 
    dropdown, 
    onDropdownChange, 
    dropdownValue, 
    dropdownOptions, 
    dropdownLabel 
  }) => (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        background: isDarkMode 
          ? 'linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%)'
          : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        borderRadius: 3,
        border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
        overflow: 'hidden'
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: isDarkMode ? '#fff' : '#1a1a1a'
            }}
          >
            {title}
          </Typography>
          <Box display="flex" alignItems="center" gap={2}>
            {dropdown && dropdownOptions && dropdownOptions.length > 0 && (
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id={`${title}-dropdown-label`}>{dropdownLabel}</InputLabel>
                <Select
                  labelId={`${title}-dropdown-label`}
                  value={dropdownValue || ''}
                  label={dropdownLabel}
                  onChange={(e) => onDropdownChange(e.target.value)}
                  sx={{
                    bgcolor: isDarkMode ? '#2a2a2a' : '#fff',
                    color: isDarkMode ? '#fff' : '#1a1a1a',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: isDarkMode ? '#404040' : '#ccc'
                    }
                  }}
                >
                  {dropdownOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.name || String(option.value)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {action}
          </Box>
        </Box>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height={250}>
            <CircularProgress />
          </Box>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: isDarkMode ? '#0a0a0a' : '#f5f7fa',
        p: { xs: 2, md: 4 }
      }}
    >
      <Loader loading={loading} />
      <ToastContainer />
      
      <Box mb={4}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            color: isDarkMode ? '#fff' : '#1a1a1a',
            mb: 1
          }}
        >
          Dashboard Overview
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: isDarkMode ? '#b0b0b0' : '#666'
          }}
        >
          Monitor your platform metrics and analytics
        </Typography>
      </Box>

      <Grid2 container spacing={3}>
        {/* Stats Cards */}
        <Grid2 xs={12} sm={6} md={3}>
          <StatCard
            title="Individual Users"
            value={imageCardData.individualUsers}
            icon={PeopleIcon}
            color="#667eea"
            linkTo="/manageuser"
          />
        </Grid2>

        <Grid2 xs={12} sm={6} md={3}>
          <StatCard
            title="Organizations"
            value={imageCardData.registeredOrganization}
            icon={BusinessIcon}
            color="#764ba2"
            subtitle={`Total Users: ${imageCardData.totalOrgUsers}`}
            linkTo="/manageorganizations"
          />
        </Grid2>

        <Grid2 xs={12} sm={6} md={3}>
          <StatCard
            title="Total Documents"
            value={dashboardData.totalDocuments.toLocaleString()}
            icon={DocumentIcon}
            color="#f093fb"
          />
        </Grid2>

        <Grid2 xs={12} sm={6} md={3}>
          <StatCard
            title="Paid Users"
            value={dashboardData.totalPaidUser.toLocaleString()}
            icon={PaidUserIcon}
            color="#4facfe"
            subtitle={`Free Users: ${dashboardData.totalFreeUser.toLocaleString()}`}
          />
        </Grid2>

        {/* User Plans Breakdown - Pie Chart */}
        <Grid2 xs={12} md={4}>
          <ChartCard 
            title="User Plans Breakdown"
          >
            {userPlanBreakdownPieChart.length > 0 ? (
              <>
                <PieChart
                  series={[
                    {
                      data: userPlanBreakdownPieChart,
                      innerRadius: 0,
                      outerRadius: 80,
                      paddingAngle: 2,
                      cornerRadius: 4,
                      highlightScope: { fade: 'global', highlight: 'item' },
                      arcLabel: (item) => `${item.value}%`,
                      arcLabelMinAngle: 20,
                    }
                  ]}
                  slotProps={{
                    legend: {
                      hidden: true,
                    },
                    tooltip: {
                      slotProps: {
                        popper: {
                          sx: {
                            '& .MuiChartsTooltip-paper': {
                              bgcolor: isDarkMode ? '#1a1a1a' : '#fff',
                              border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
                              borderRadius: '8px'
                            }
                          }
                        }
                      }
                    }
                  }}
                  sx={{
                    '& .MuiChartsTooltip-cell': {
                      color: isDarkMode ? '#fff' : '#1a1a1a'
                    }
                  }}
                  height={250}
                />
                <Box mt={2}>
                  {userPlanBreakdownPieChart.map((item, index) => (
                    <Box
                      key={index}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={1}
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            bgcolor: item.color
                          }}
                        />
                        <Typography variant="body2" sx={{ color: isDarkMode ? '#b0b0b0' : '#666' }}>
                          {item.label}
                        </Typography>
                      </Box>
                      <Typography variant="body2" sx={{ color: isDarkMode ? '#fff' : '#1a1a1a', fontWeight: 600 }}>
                        {item.value}%
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </>
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" height={250}>
                <Typography color="text.secondary">No data available</Typography>
              </Box>
            )}
          </ChartCard>
        </Grid2>

        {/* Country Breakdown - Pie Chart */}
        <Grid2 xs={12} md={8}>
          <ChartCard title="User Country Breakdown">
            {countryCodePieChart.length > 0 ? (
              <>
                <PieChart
                  series={[
                    {
                      data: countryCodePieChart,
                      innerRadius: 0,
                      outerRadius: 80,
                      paddingAngle: 2,
                      cornerRadius: 4,
                      highlightScope: { fade: 'global', highlight: 'item' },
                      arcLabel: (item) => `${item.value}%`,
                      arcLabelMinAngle: 20,
                    }
                  ]}
                  slotProps={{
                    legend: {
                      hidden: true,
                    },
                    tooltip: {
                      slotProps: {
                        popper: {
                          sx: {
                            '& .MuiChartsTooltip-paper': {
                              bgcolor: isDarkMode ? '#1a1a1a' : '#fff',
                              border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
                              borderRadius: '8px'
                            }
                          }
                        }
                      }
                    }
                  }}
                  sx={{
                    '& .MuiChartsTooltip-cell': {
                      color: isDarkMode ? '#fff' : '#1a1a1a'
                    }
                  }}
                  height={250}
                />
                <Grid2 container spacing={2} mt={1}>
                  {countryCodePieChart.map((item, index) => (
                    <Grid2 xs={6} sm={3} key={index}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            bgcolor: item.color
                          }}
                        />
                        <Box>
                          <Typography variant="body2" sx={{ color: isDarkMode ? '#b0b0b0' : '#666' }}>
                            {item.label}
                          </Typography>
                          <Typography variant="body2" sx={{ color: isDarkMode ? '#fff' : '#1a1a1a', fontWeight: 600 }}>
                            {item.value}%
                          </Typography>
                        </Box>
                      </Box>
                    </Grid2>
                  ))}
                </Grid2>
              </>
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" height={250}>
                <Typography color="text.secondary">No data available</Typography>
              </Box>
            )}
          </ChartCard>
        </Grid2>

        {/* Organization Users Chart - Bar Chart */}
        <Grid2 xs={12} md={6}>
          <ChartCard
            title="Organization Users Growth"
            dropdown={true}
            dropdownLabel="Year"
            dropdownValue={barChartYear}
            dropdownOptions={yearList}
            onDropdownChange={handleBarChartYearChange}
            action={
              <Chip
                label={dashboardData.selectYear}
                size="small"
                sx={{
                  bgcolor: isDarkMode ? '#404040' : '#f0f0f0',
                  color: isDarkMode ? '#fff' : '#1a1a1a'
                }}
              />
            }
          >
            {orgUserBarChart.bar.length > 0 ? (
              <BarChart
                series={orgUsersSeries}
                xAxis={[
                  {
                    data: xAxisData,
                    scaleType: 'band',
                    tickLabelStyle: {
                      fontSize: '12px',
                      fill: isDarkMode ? '#b0b0b0' : '#666'
                    }
                  }
                ]}
                yAxis={[
                  {
                    tickLabelStyle: {
                      fontSize: '12px',
                      fill: isDarkMode ? '#b0b0b0' : '#666'
                    }
                  }
                ]}
                grid={{ vertical: true, horizontal: true }}
                borderRadius={8}
                slotProps={{
                  tooltip: {
                    slotProps: {
                      popper: {
                        sx: {
                          '& .MuiChartsTooltip-paper': {
                            bgcolor: isDarkMode ? '#1a1a1a' : '#fff',
                            border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
                            borderRadius: '8px'
                          }
                        }
                      }
                    }
                  }
                }}
                sx={{
                  '& .MuiBarElement-root': {
                    fill: 'url(#colorUsers)'
                  },
                  '& .MuiChartsAxis-line': {
                    stroke: isDarkMode ? '#404040' : '#e0e0e0'
                  },
                  '& .MuiChartsAxis-tick': {
                    stroke: isDarkMode ? '#404040' : '#e0e0e0'
                  },
                  '& .MuiChartsGrid-line': {
                    stroke: isDarkMode ? '#404040' : '#e0e0e0',
                    strokeDasharray: '3 3'
                  }
                }}
                height={280}
              >
                <defs>
                  <linearGradient id="colorUsers" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#667eea" stopOpacity={0.9}/>
                    <stop offset="95%" stopColor="#764ba2" stopOpacity={0.9}/>
                  </linearGradient>
                </defs>
              </BarChart>
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" height={280}>
                <Typography color="text.secondary">No data available</Typography>
              </Box>
            )}
          </ChartCard>
        </Grid2>

        {/* Organization Users Plan Breakdown */}
        <Grid2 xs={12} md={6}>
          <ChartCard
            title="Organization Users Plan Breakdown"
            dropdown={true}
            dropdownLabel="Organization"
            dropdownValue={pieChartOrg}
            dropdownOptions={organizationList}
            onDropdownChange={handlePieChartOrgChange}
          >
            {orgUsersPlanBreakdown.length > 0 ? (
              <>
                <PieChart
                  series={[
                    {
                      data: orgUsersPlanBreakdown,
                      innerRadius: 0,
                      outerRadius: 80,
                      paddingAngle: 2,
                      cornerRadius: 4,
                      highlightScope: { fade: 'global', highlight: 'item' },
                      arcLabel: (item) => `${item.value}%`,
                      arcLabelMinAngle: 20,
                    }
                  ]}
                  slotProps={{
                    legend: {
                      hidden: true,
                    },
                    tooltip: {
                      slotProps: {
                        popper: {
                          sx: {
                            '& .MuiChartsTooltip-paper': {
                              bgcolor: isDarkMode ? '#1a1a1a' : '#fff',
                              border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
                              borderRadius: '8px'
                            }
                          }
                        }
                      }
                    }
                  }}
                  sx={{
                    '& .MuiChartsTooltip-cell': {
                      color: isDarkMode ? '#fff' : '#1a1a1a'
                    }
                  }}
                  height={250}
                />
                <Grid2 container spacing={2} mt={1}>
                  {orgUsersPlanBreakdown.map((item, index) => (
                    <Grid2 xs={6} key={index}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            bgcolor: item.color
                          }}
                        />
                        <Box>
                          <Typography variant="body2" sx={{ color: isDarkMode ? '#b0b0b0' : '#666' }}>
                            {item.label}
                          </Typography>
                          <Typography variant="body2" sx={{ color: isDarkMode ? '#fff' : '#1a1a1a', fontWeight: 600 }}>
                            {item.value}%
                          </Typography>
                        </Box>
                      </Box>
                    </Grid2>
                  ))}
                </Grid2>
              </>
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" height={250}>
                <Typography color="text.secondary">Select an organization to view data</Typography>
              </Box>
            )}
          </ChartCard>
        </Grid2>

        {/* Monthly Active Users - Line Chart */}
        <Grid2 xs={12}>
          <ChartCard
            title="Monthly Active Users"
            dropdown={true}
            dropdownLabel="Year"
            dropdownValue={dashboardData.selectYear}
            dropdownOptions={dashboardData.years.map(year => ({ value: year, name: year }))}
            onDropdownChange={handleYearChange}
          >
            {dashboardData.monthwisePaidusers.length > 0 ? (
              <LineChart
                series={monthlyActiveSeries}
                xAxis={[
                  {
                    data: dashboardData.monthList.slice(0, dashboardData.monthwisePaidusers.length),
                    scaleType: 'band',
                    tickLabelStyle: {
                      fontSize: '12px',
                      fill: isDarkMode ? '#b0b0b0' : '#666'
                    }
                  }
                ]}
                yAxis={[
                  {
                    tickLabelStyle: {
                      fontSize: '12px',
                      fill: isDarkMode ? '#b0b0b0' : '#666'
                    }
                  }
                ]}
                grid={{ vertical: true, horizontal: true }}
                slotProps={{
                  tooltip: {
                    slotProps: {
                      popper: {
                        sx: {
                          '& .MuiChartsTooltip-paper': {
                            bgcolor: isDarkMode ? '#1a1a1a' : '#fff',
                            border: `1px solid ${isDarkMode ? '#404040' : '#e0e0e0'}`,
                            borderRadius: '8px'
                          }
                        }
                      }
                    }
                  }
                }}
                sx={{
                  '& .MuiLineElement-root': {
                    stroke: 'url(#colorLine)',
                    strokeWidth: 3
                  },
                  '& .MuiMarkElement-root': {
                    fill: '#667eea',
                    strokeWidth: 0
                  },
                  '& .MuiChartsAxis-line': {
                    stroke: isDarkMode ? '#404040' : '#e0e0e0'
                  },
                  '& .MuiChartsAxis-tick': {
                    stroke: isDarkMode ? '#404040' : '#e0e0e0'
                  },
                  '& .MuiChartsGrid-line': {
                    stroke: isDarkMode ? '#404040' : '#e0e0e0',
                    strokeDasharray: '3 3'
                  }
                }}
                height={280}
              >
                <defs>
                  <linearGradient id="colorLine" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="5%" stopColor="#667eea" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#764ba2" stopOpacity={0.8}/>
                  </linearGradient>
                </defs>
              </LineChart>
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" height={280}>
                <Typography color="text.secondary">No data available</Typography>
              </Box>
            )}
          </ChartCard>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default ModernAdminDashboard;